import React from 'react';
import { InstagramIcon } from 'lucide-react';
type BrandIconProps = {
  name: 'instagram' | 'tiktok' | 'soundcloud' | 'spotify';
  className?: string;
};
export function BrandIcon({
  name,
  className = 'h-5 w-5'
}: BrandIconProps) {
  if (name === 'instagram') {
    return <InstagramIcon className={className} aria-hidden="true" data-id="element-17" data-mp="2cpqggdsah24n" />;
  }
  if (name === 'tiktok') {
    return <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-18" data-mp="27qdioxzvqana">
        <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.1v12.4a2.6 2.6 0 1 1-1.86-2.5V9.7a5.7 5.7 0 1 0 4.96 5.65V8.9a7.32 7.32 0 0 0 4.3 1.38V7.2a4.3 4.3 0 0 1-3.24-1.38Z" data-id="element-19" data-mp="22zx61g3vut1z" />
      </svg>;
  }
  if (name === 'spotify') {
    return <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-20" data-mp="1u0a14kby3546">
        <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.55 14.42a.78.78 0 0 1-1.07.26c-2.93-1.79-6.62-2.2-10.97-1.2a.78.78 0 1 1-.35-1.52c4.74-1.08 8.83-.61 12.1 1.39.37.22.48.7.29 1.07Zm1.22-2.72a.97.97 0 0 1-1.34.32c-3.35-2.06-8.46-2.66-12.42-1.45a.97.97 0 1 1-.57-1.86c4.53-1.38 10.16-.71 14.01 1.65.46.28.6.88.32 1.34Zm.1-2.83c-4.02-2.39-10.65-2.61-14.49-1.44a1.17 1.17 0 1 1-.68-2.23C7.13 5.86 14.45 6.1 19.08 8.85a1.17 1.17 0 0 1-1.2 2.01Z" data-id="element-21" data-mp="1oz478j6jtbt2" />
      </svg>;
  }
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-22" data-mp="38d6c2jrm5tfo">
      <path d="M2 13.5v3h1.2v-3H2Zm2.4-2v5h1.2v-5H4.4Zm2.4-1.5v6.5H8V10H6.8Zm2.4-1v7.5h1.2V9H9.2Zm2.4-1.2v8.7h1.2V7.8h-1.2Zm2.4 1.2v7.5h1.2V9H14Zm3.9 1.1c-.4 0-.8.08-1.14.23v6.17H19.6a2.55 2.55 0 0 0 .25-5.08 2.6 2.6 0 0 0-1.95-1.32Z" data-id="element-23" data-mp="3w2qvt4vlcuq0" />
    </svg>;
}